export default __webpack_public_path__ + "static/media/marker-beacon.4a688769.svg";